import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import { connect } from 'react-redux';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import {maskPhone} from '../../utils/index';
import {Formik} from 'formik';
import {
    getToken,
    getTokenReset,
    loginStep1ConfirmationCode,
    idpLogin
} from "../../actions/security";
import loadable from "../../components/Lazy";
import LoginErrorModal from "../../components/Modals/LoginErrorModal";
import SocialLoginButton from "../../components/SocialLoginButton";
import {
    BrowserRouter as Router,
    useHistory
} from "react-router-dom";
import IconButton from "../Button/IconButton";
import {
    setLoadingSpinnerOpen,
} from '../../actions/loadingSpinner';

const Recaptcha = loadable(() => import('../../components/App/Recaptcha'));

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: '480px',
        margin: '50px auto'
    },
}));

const Login = ({
    getToken,
    token,
    getTokenReset,
    getTokenSuccess,
    loginStep1ConfirmationCode,
    idpLogin,
    setLoadingSpinnerOpen
}) => {
    const classes = useStyles();
    const history = useHistory();
    const [howGiftYaUsesTextMessagesOpen, setHowGiftYaUsesTextMessagesOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loginToken, setLoginToken] = useState('');

    const handleSubmit = (values) => {
        loginStep1ConfirmationCode({
            username: values.username.replace(/[^0-9]/g, ''),
            token: loginToken,
            recaptchaToken: values.recaptchaToken,
            // redirect: `${window.location.origin}/secure/account/received`
        })
    };

    useEffect(() => {
        getToken({name: 'gift_ya_send_code'})
    }, [getToken]);

    useEffect(() => {
        if (getTokenSuccess) {
            setLoginToken(token);
            getTokenReset();
        }
    }, [getTokenSuccess, getTokenReset, token])

    return (
        <Router>

            <Container>
                <LoginErrorModal />
                <div className={classes.root}>
                    <Formik
                        enableReinitialize={true}
                        validateOnMount={true}
                        initialValues={{
                            username: '',
                            recaptchaToken: ''
                        }}
                        validate={(values) => {
                            const errors = {
                                ...(!/^[0-9]{10}$/gim.test(values.username.replace(/[^0-9]/g, '')) && {username: 'Please enter a valid phone number'}),
                            };
                            if (Object.keys(errors).length > 0) {
                                setIsSubmitting(false);
                            }
                            return errors;
                        }}
                        onSubmit={handleSubmit}>
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            setFieldValue,
                            submitForm,
                            isValid,
                            dirty
                        }) => {

                            const handleRecaptchaSubmit = (recaptchaToken) => {
                                setFieldValue('recaptchaToken', recaptchaToken)
                                setIsSubmitting(true)
                                submitForm();
                            };
                            return (
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <div style={{marginBottom: '40px'}}>
                                            <Typography variant="h2" component="h1" align="center" gutterBottom={true}>Sign in to continue</Typography>
                                            <Typography gutterBottom={true} align="center">We will send a code to your phone to make sure it’s you.</Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            onChange={(e) => {
                                                const value = e.target.value || "";
                                                setFieldValue('username', maskPhone(value));
                                            }}
                                            fullWidth={true}
                                            label="Mobile phone number"
                                            variant="filled"
                                            color="primary"
                                            value={values.username}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Recaptcha
                                            onSubmit={handleRecaptchaSubmit}
                                        >
                                            {({submitAction}) => {
                                                const handleClick = (e) => {
                                                    setLoadingSpinnerOpen(true);
                                                    submitAction(e);
                                                }
                                                return (
                                                    <Button
                                                        loading={isSubmitting}
                                                        onClick={handleClick}
                                                        disabled={!isValid || !token || isSubmitting}
                                                        fullWidth
                                                        variant="contained"
                                                        color="primary"
                                                    >
                                                        Get confirmation code
                                                    </Button>
                                                );
                                            }}
                                        </Recaptcha>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider style={{marginTop: '50px'}} />
                                    </Grid>
                                    {/*<Grid item xs={12} style={{textAlign: 'center'}}>*/}
                                    {/*    <Button onClick={handleBackClick}>Back</Button>*/}
                                    {/*</Grid>*/}
                                </Grid>
                            )}}
                    </Formik>
                </div>

                <div style={{marginBottom: '50px', marginTop: '50px'}}>

                    <Typography align="center">or continue with</Typography>
                    <Grid container spacing={2} justifyContent="center">
                        <Grid item>
                            <SocialLoginButton
                                history={history}
                                idpService="google"
                                loginCallback={idpLogin}
                                Component={IconButton}
                                ComponentProps={{}}
                            >
                                <img src="https://res.cloudinary.com/giftya-llc/image/upload/v1670012516/Design%20Assets/Icons/Google_-_Original_cnbkpz.svg" alt="" />
                            </SocialLoginButton>
                        </Grid>
                        <Grid item>
                            <SocialLoginButton
                                history={history}
                                idpService="facebook"
                                loginCallback={idpLogin}
                                Component={IconButton}
                                ComponentProps={{}}
                            >
                                <img src="https://res.cloudinary.com/giftya-llc/image/upload/v1670012610/Design%20Assets/Icons/Facebook_-_Original_outyaa.svg" alt="" />
                            </SocialLoginButton>
                        </Grid>
                        {/*<Grid item>*/}
                        {/*    <SocialLoginButton*/}
                        {/*        history={history}*/}
                        {/*        idpService="twitter"*/}
                        {/*        loginCallback={idpLogin}*/}
                        {/*        Component={IconButton}*/}
                        {/*        ComponentProps={{}}*/}
                        {/*    >*/}
                        {/*        <img src="https://res.cloudinary.com/giftya-llc/image/upload/v1670012622/Design%20Assets/Icons/Twitter_-_Original_frhd3a.svg" alt="" />*/}
                        {/*    </SocialLoginButton>*/}
                        {/*</Grid>*/}


                        <Grid item xs={12} style={{textAlign: 'center', marginTop: '40px'}}>
                            <Button onClick={() => {setHowGiftYaUsesTextMessagesOpen(!howGiftYaUsesTextMessagesOpen)}} color="primary" endIcon={<InfoOutlinedIcon />}>How GiftYa uses text messages</Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Collapse in={howGiftYaUsesTextMessagesOpen}>
                                <Paper style={{padding: '16px'}} variant="outlined">
                                    <Typography align="center">
                                        <small>GiftYa will notify you via text message when your gift is delivered (1 message per gift). At any time, you can opt out of text messages through your GiftYa account or by replying with STOP. Text HELP for support. Message and data rates may apply. View GiftYa's SMS terms of service and privacy policy.</small>
                                    </Typography>
                                </Paper>
                            </Collapse>
                        </Grid>
                        <Grid item xs={12} style={{marginBottom: '80px', marginLeft: 'auto', marginRight: 'auto', maxWidth: '400px'}}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item>
                                    <LockOutlinedIcon />
                                </Grid>
                                <Grid item xs>
                                    <Typography>
                                        <small>This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.</small>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </Container>
        </Router>
    )
}

export default connect(
    (state) => ({
        getTokenSuccess: state.security.getTokenSuccess,
        getTokenError: state.security.getTokenError,
        token: state.security.token,
    }),
    {
        getToken,
        getTokenReset,
        loginStep1ConfirmationCode,
        idpLogin,
        setLoadingSpinnerOpen
    }
)(Login);